import { makeRequest, Service, identify } from 'utils/http';
import { CreateOrderRequest } from 'trace-backend-sdk';

export async function createOrderApi(order: CreateOrderRequest) {
  return makeRequest(Service.createOrder(order, await identify()));
}
